
<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>CMS Global Settings</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">CMS Global Settings</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
        <div class="container-fluid">
          <div class="card" id="CMSGlobalSetting">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <form @submit.prevent="handleSubmission()" method="POST" novalidate>
              <div class="card-header">
                <h3 class="card-title" v-if="!is_edit">Create</h3>
                <h3 class="card-title" v-if="is_edit">Edit</h3>
                <div class="card-tools">
                  <router-link class="btn btn-info" :to="{name: 'CMSGlobalSettingList'}"><i class="fas fa-list"></i> List
                  </router-link>
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                    <div class="col-8">


            <div class="form-group required" >
              <label class="control-label">Site Title</label>
              <input type="text" id="site_title" name="site_title"
                     v-bind:class="{'has-error' : errors.has('site_title')}"
                     v-validate="'required'"
                     v-model="value.site_title" class="form-control site_title"
                     placeholder="Site Title">
              <div class="help text-danger" v-show="errors.has('site_title')">
                {{ errors.first("site_title") }}
              </div>
            </div>
            <div class="form-group " >
              <label class="control-label">Tag Line</label>
              <textarea id="tag_line" name="tag_line"


                 v-model="value.tag_line" class="form-control tag_line"
                 placeholder="Tag Line"
                 rows="3"></textarea>

            </div>
            <div class="form-group required" >
              <label class="control-label">Home Page</label>
              <multiselect id="home_page" name="home_page" :options="Object.keys(pre.home_page)" :custom-label="opt => pre.home_page[opt]"
                     v-bind:class="{'has-error' : errors.has('home_page')}"
                     v-validate="'required'"
                     v-model="value.home_page" class="home_page"
                     placeholder="Select Home Page" :searchable="true"
                     :close-on-select="true" :show-labels="false"></multiselect>
              <div class="help text-danger" v-show="errors.has('home_page')">
                {{ errors.first("home_page") }}
              </div>
            </div>
                    <div class="col-md-12" >
                        <h4 class="site-heading my-3"><span>Logo</span></h4>
                    </div>
                    <div class="form-group col-md-12">
                        <label for="logo_path"></label>
                        <div class="row align-items-center">
                          <div class="col-4">
                            <div class="input-group">
                              <div class="custom-file">
                                <input type="file"
                                name="logo_path" class="custom-file-input" id="logo_path" @change="select_file_logo_path">
                                <label class="custom-file-label" for="logo_path">Choose file</label>
                              </div>
                            </div>
                          </div>
                          <div class="col-8">
                            <img
                              alt="preview image"
                              v-if="value.logo_path_name"
                              v-bind:src="value.logo_path_name"
                              width="100"
                              height="100"
                              class="img-circle"
                            />
                          </div>
                          <div class="help text-danger" v-show="errors.has('logo_path')">
                {{ errors.first("logo_path") }}
              </div>
                        </div>
                    </div>

            <div class="form-group required" >
              <label class="control-label">Template</label>
              <multiselect id="template" name="template" :options="Object.keys(pre.template)" :custom-label="opt => pre.template[opt]"
                     v-bind:class="{'has-error' : errors.has('template')}"
                     v-validate="'required'"
                     v-model="value.template" class="template"
                     placeholder="Select Template" :searchable="true"
                     :close-on-select="true" :show-labels="false"></multiselect>
              <div class="help text-danger" v-show="errors.has('template')">
                {{ errors.first("template") }}
              </div>
            </div>
            <div class="form-group " >
              <label class="control-label">Header Scripts</label>
              <textarea id="header_scripts" name="header_scripts"


                 v-model="value.header_scripts" class="form-control header_scripts"
                 placeholder="Header Scripts"
                 rows="3"></textarea>

            </div>
            <div class="form-group " >
              <label class="control-label">Footer Scripts</label>
              <textarea id="footer_scripts" name="footer_scripts"


                 v-model="value.footer_scripts" class="form-control footer_scripts"
                 placeholder="Footer Scripts"
                 rows="3"></textarea>

            </div>
                    </div>
                </div>
              </div>
              <div class="card-footer">
                <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
                <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
              </div>
            </form>
          </div>
        </div>
    </section>
  </div>
</template>

<script>

//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import {DepartmentsAPI, CommonAPI} from "@/services/api";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";

export default {
  name: "CMSGlobalSettingForm",
  metaInfo: {
    title: "CMS Global Settings | Dotlines"
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {

        logo_path: '',logo_path_name:'Choose file'
    },
    pre: {
      home_page: {},template: {},
    }
  }),
  methods: {

    select_file_logo_path: function (event) {
      try {
         let reader = new FileReader();
         reader.readAsDataURL(event.target.files[0])
         reader.onload = () => {
           this.value.logo_path = reader.result;
           this.value.logo_path_name = reader.result;
           //this.$set(this.value, 'logo_path_name', event.target.files[0].name)
         };
       } catch (e) {
         //console.log(e);
       }
    },


    homePageOptions: function () {
      return new Promise((resolve, reject) => {
        axios.get("/get-dropdown-options/1")
          .then(response => {
            resolve(response.data);
            //return response.data;
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    templateOptions: function () {
      return new Promise((resolve, reject) => {
        axios.get("/get-dropdown-options/2")
          .then(response => {
            resolve(response.data);
            //return response.data;
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/cms_global_settings";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/cms_global_settings/" + _this.$route.params.id
            method = "PUT";
          }
          axios({
            method: method, url: api_url,
            data: _this.value,
            headers: {"Content-Type": "application/json"},
          }).then(function (response) {
            _this.$toaster.success(response.data.message);
            _this.$router.push({"name": "CMSGlobalSettingList"});
          }).catch((errors) => {
            if (errors.response.status === 500) {
              _this.$toaster.error(errors.response.data.message);
            }
            _this.$setErrorsFromResponse(errors.response.data);
          }).finally(() => {
            _this.is_loading = false;
          });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/cms_global_settings/" + id;
        axios.get(api_url)
          .then(response => {
            resolve(response);
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;
      await this.homePageOptions().then(home_page => {
        this.pre.home_page = home_page;
      });
      await this.templateOptions().then(template => {
        this.pre.template = template;
      });

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id).then(response => {
          this.value = response.data;
        }).catch((error) => {
          console.log(error.response);
        });

        this.value.logo_path_name = this.API_ASSET_UPLOAD_URL + this.value.logo_path
        this.$delete(this.value, "logo_path")
        //this.value.logo_path = ''

      }

      this.is_loading = false;
    }
  },
  mounted() {
    this.initialize()
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
}
</script>

